import { useEffect, useMemo } from "react";

import { useProjectActions, useProjectContext } from "@contexts/projects";

import ProjectionLoadState from "../../financialProjection/ProjectionLoadState";
import EapRuleRow from "./EapRuleRow";
import ServiceAccordion from "./ServiceAccordion";

const SubstepAccordion = ({ parent, months }) => {
  const {
    activeProject: { _id, substeps = {} },
    filterDates,
    projectionScopeGeneration,
  } = useProjectContext();
  const { loadSubsteps } = useProjectActions();

  // Change 00 (D11): depois de salvar, a geração nova recarrega a linha aberta.
  useEffect(() => {
    if (_id) loadSubsteps(parent);
  }, [_id, parent, filterDates, projectionScopeGeneration]);

  const stepSubsteps = useMemo(() => substeps[parent], [substeps, parent]);

  return (
    <>
      <ProjectionLoadState
        level="substeps"
        parent={parent}
        isMissing={!stepSubsteps}
        onRetry={() => loadSubsteps(parent)}
      />
      {stepSubsteps?.map((item) => (
        <EapRuleRow
          key={item.wbs_code_id}
          item={item}
          type="substep"
          typeTitle="Subetapa"
          months={months}
          ChildAccordionComponent={ServiceAccordion}
        />
      ))}
    </>
  );
};

export default SubstepAccordion;
